import { ComponentThemeType } from './theme.types';

export const tabsTheme: ComponentThemeType = {
  MuiTabs: {
    styleOverrides: {
      flexContainer: ({ theme: { palette } }) => ({
        '.MuiButtonBase-root': {
          minWidth: 20,
          textTransform: 'none',
          color: palette.tertiary.light,
        },
        '.MuiButtonBase-root.Mui-selected': {
          color: palette.primary.main,
        },
      }),
    },
  },
  MuiBreadcrumbs: {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        color: palette.tertiary.light,
        '.MuiTypography-root': {
          color: palette.tertiary.light,
        },
      }),
    },
  },
};
